import axios from "axios";

// http://webf/WebAPI/Admin/AdMedicalApi/api/
// https://weba.cych.org.tw/AdMedicalApi/api/
const AdMedicalApi = axios.create({
  baseURL: `https://weba.cych.org.tw/AdMedicalApi/api/`,
});
AdMedicalApi.defaults.timeout = 10000;

export default {
  AdMedicalApi,
};
